import { Base64 } from 'js-base64';
import { useEffect, useRef, useState } from 'react';

/**
 * Hook pour charger le contenu de l'éditeur à partir du brouillon.
 * Assure un chargement initial unique pour éviter d'écraser les modifications utilisateur.
 */
export const useLoadEditorContent = ({
  draft,
  setMessage,
  isDraftSet,
  recipientType,
}) => {
  const [isEditorContentLoaded, setIsEditorContentLoaded] = useState(false);
  const hasLoadedInitialContentRef = useRef(false);
  const lastLoadedDraftIdRef = useRef(null);
  const lastLoadedRecipientTypeRef = useRef(null);

  useEffect(() => {
    const isRecipientTypeChanged =
      recipientType !== lastLoadedRecipientTypeRef.current;
    const isDraftIdChanged =
      draft && draft._id !== lastLoadedDraftIdRef.current;

    // Réinitialise les flags de chargement si le contexte (type de destinataire ou ID de brouillon) change.
    if (isRecipientTypeChanged || isDraftIdChanged) {
      hasLoadedInitialContentRef.current = false;
      lastLoadedDraftIdRef.current = draft ? draft._id : null;
      lastLoadedRecipientTypeRef.current = recipientType;
      setIsEditorContentLoaded(false);
    }

    // Charge le contenu du brouillon si l'éditeur est prêt et non déjà chargé.
    if (recipientType && isDraftSet && !hasLoadedInitialContentRef.current) {
      const body = draft?.htmlBody || draft?.txtBody;
      const decodedBody = Base64.decode(body || '');
      setMessage(decodedBody);
      setIsEditorContentLoaded(true);
      hasLoadedInitialContentRef.current = true;
    }
    // Vide le message si le type de destinataire est réinitialisé.
    else if (recipientType === null) {
      if (isEditorContentLoaded || hasLoadedInitialContentRef.current) {
        setMessage('');
        setIsEditorContentLoaded(false);
        hasLoadedInitialContentRef.current = false;
        lastLoadedDraftIdRef.current = null;
        lastLoadedRecipientTypeRef.current = null;
      }
    }
  }, [draft, isDraftSet, setMessage, recipientType]);

  return { isEditorContentLoaded };
};
